const listReviewClasses = {
  container:
    'border rounded border-slate-700 p-8 gap-4 mb-4 w-full lg:w-3/4 mx-auto',
  flexContainer:
    'flex 2xl:flex-row-reverse flex-col-reverse gap-6 items-center',
  flexColContainer: 'flex flex-col w-5/6 gap-2',
  image:
    'w-full xl:w-3/4 m-auto border border-slate-700 object-contain max-h-[400px]',
  delete: 'cursor-pointer bg-gray-800 hover:bg-gray-900 rounded-full px-2 py-1',
}

export default listReviewClasses
